export const FREQUENCY_DIVISIONS = {
  MONTHLY: { count: 12, label: 'Monthly (12 Months)', itemPrefix: 'Month' },
  QUARTERLY: { count: 4, label: 'Quarterly (4 Quarters)', itemPrefix: 'Quarter' },
  HALF_YEARLY: { count: 2, label: 'Half Yearly (2 Semesters)', itemPrefix: 'Semester' },
  YEARLY: { count: 1, label: 'Yearly (1 Payment)', itemPrefix: 'Annual' },
  ANNUALLY: { count: 1, label: 'Yearly (1 Payment)', itemPrefix: 'Annual' },
  ONE_TIME: { count: 1, label: 'One Time (1 Payment)', itemPrefix: 'Full' },
  PER_TERM: { count: 3, label: 'Per Term (3 Terms)', itemPrefix: 'Term' },
  CUSTOM: { count: 1, label: 'Custom (1 Payment)', itemPrefix: 'Installment' },
};
